import React, { Component } from 'react'
import { Modal, Button } from 'hljd'
import { observer } from 'mobx-react'
import { hashHistory } from 'react-router'
import { SHOP_PRODUCTS_PATH } from '@constant'
import { getProTitle } from '@util'

@observer
export default class extends Component {
  render() {
    const {
      confirmModalVisible,
      continueOrder,
      cancelModal,
      checkedField
    } = this.props.store
    const title = getProTitle()
    return (
      <Modal
        width={526}
        visible={confirmModalVisible}
        onCancel={cancelModal('confirmModalVisible')}
        title={''}
        footer={[
          <Button key="back" onClick={continueOrder}>
            继续下单
          </Button>,
          <Button
            key="submit"
            type="primary"
            onClick={() => hashHistory.push(SHOP_PRODUCTS_PATH)}
          >
            去开通{title}
          </Button>
        ]}
      >
        <div style={{ fontSize: 18, padding: 22 }}>
          如果开通{title}，您将节省{checkedField.pro_save_price}元
        </div>
      </Modal>
    )
  }
}
